// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import cn from 'classnames';
import ToggleButtonGroup from 'react-bootstrap/lib/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/lib/ToggleButton';
import Button from 'react-bootstrap/lib/Button';

type Props = {
  className: string,
};

const ToggleButtonGroupAction = ({
  className = '',
  type,
  value,
  options,
  onChange,
  name,
  disabled,
  allowClear = false,
}: Props) => {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <ToggleButtonGroup
        type={type}
        value={value}
        onChange={onChange}
        name={name}
      >
        {options.map((option, index) => (
          <ToggleButton
            bsClass={cn(className, 'btn')}
            css={{
              padding: '2px 10px',
              appearance: 'none !important',
              border: '1px solid rgba(0,0,0,.2)',
              borderWidth: `0 ${index === options.length - 1 ? '0' : '1px'} 0 ${
                index === 0 ? '0' : '1px'
              }`,
            }}
            key={option.value}
            value={option.value}
            disabled={disabled}
          >
            {option.text}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {value && allowClear && (
        <Button
          bsStyle="link"
          onClick={() => {
            onChange();
          }}
          disabled={disabled}
        >
          clear
        </Button>
      )}
    </div>
  );
};

export default ToggleButtonGroupAction;
